import InsuranceForm from './InsuranceForm';

import PrimaryForm from './PrimaryForm';
import MemberId from './MemberId';
import AllowDepReg from './AllowDepReg';

export default InsuranceForm;
export { PrimaryForm, MemberId, AllowDepReg };
